var _rect, _ellipse, _path, _path2, _path3, _path4, _ellipse2, _path5, _rect2, _rect3, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.9256,
    cy: 50.4145,
    rx: 29.4158,
    ry: 29.0571,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6171 55.1351C16.5476 61.8525 19.4737 68.1464 24.0254 73.2211C28.5771 78.2957 34.5499 81.9231 41.1886 83.6446C47.8273 85.366 54.8337 85.1042 61.3218 82.8923C67.8099 80.6803 73.4883 76.6176 77.6389 71.2178L72.6159 67.4505C69.2197 71.8689 64.5732 75.1934 59.2643 77.0033C53.9553 78.8133 48.2222 79.0275 42.7899 77.6189C37.3577 76.2103 32.4703 73.2421 28.7458 69.0897C25.0213 64.9373 22.627 59.7872 21.8656 54.2906L15.6171 55.1351Z",
    fill: "#9AC869"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6171 55.1351C16.5476 61.8525 19.4737 68.1464 24.0254 73.2211C28.5771 78.2957 34.5499 81.9231 41.1886 83.6446C47.8273 85.366 54.8337 85.1042 61.3218 82.8923C67.8099 80.6803 73.4883 76.6176 77.6389 71.2178L75.2376 69.4168C71.4476 74.3475 66.2626 78.0573 60.3382 80.077C54.4138 82.0968 48.0161 82.3359 41.9541 80.764C35.8922 79.1921 30.4382 75.8798 26.282 71.246C22.1258 66.6123 19.4539 60.8651 18.6043 54.7314L15.6171 55.1351Z",
    fill: "#82B448"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7421 37.8474C20.273 31.5452 24.639 26.1259 30.2879 22.2748C35.9367 18.4237 42.6149 16.3137 49.4777 16.2117C56.3406 16.1097 63.08 18.0202 68.8436 21.7017C74.6072 25.3832 79.1363 30.6703 81.858 36.8944L76.0683 39.3648C73.8412 34.2718 70.1352 29.9455 65.4191 26.9331C60.7029 23.9207 55.1883 22.3573 49.5726 22.4408C43.957 22.5243 38.4925 24.2508 33.8702 27.4021C29.2479 30.5533 25.6754 34.9877 23.6045 40.1446L17.7421 37.8474Z",
    fill: "#9AC869"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7421 37.8474C20.273 31.5452 24.639 26.1259 30.2879 22.2748C35.9367 18.4237 42.6149 16.3137 49.4777 16.2117C56.3406 16.1097 63.08 18.0202 68.8436 21.7017C74.6072 25.3832 79.1363 30.6703 81.858 36.8944L78.5267 38.3158C76.0896 32.7425 72.0342 28.0083 66.8732 24.7117C61.7122 21.4152 55.6776 19.7044 49.5323 19.7958C43.3871 19.8871 37.4073 21.7765 32.3491 25.2249C27.2908 28.6733 23.3814 33.526 21.1152 39.1691L17.7421 37.8474Z",
    fill: "#84B749"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.149,
    cy: 50.6349,
    rx: 24.1284,
    ry: 23.8341,
    fill: "#74B3F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4702 29.2116C72.4724 34.9309 77.5084 49.1783 71.7185 61.0341C72.3893 61.3538 76.5115 40.3228 57.145 31.9571C50.0493 29.556 37.7786 28.6092 28.2548 40.3228C34.0447 28.4669 48.468 23.4923 60.4702 29.2116Z",
    fill: "#4E9EEC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48.6597,
    y: 39.0122,
    width: 2.97881,
    height: 10.2987,
    rx: 1.48941,
    fill: "#073D80"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.96275,
    height: 12.2952,
    rx: 1.48137,
    transform: "matrix(0.749806 0.661658 -0.67075 0.741683 47.97 51.959)",
    fill: "#073D80"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.1488,
    cy: 50.635,
    rx: 3.57458,
    ry: 3.53098,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.1489,
    cy: 50.6346,
    rx: 1.78729,
    ry: 1.76549,
    fill: "#3D3434"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.1494,
    cy: 30.6261,
    rx: 1.19188,
    ry: 1.17734,
    fill: "#3D3434"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.7032,
    cy: 52.401,
    rx: 1.19188,
    ry: 1.17734,
    fill: "#3D3434"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.4691,
    cy: 41.8077,
    rx: 1.19188,
    ry: 1.17734,
    fill: "#3D3434"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.3197,
    cy: 33.8629,
    rx: 1.19188,
    ry: 1.17734,
    fill: "#3D3434"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.6596,
    cy: 67.9957,
    rx: 1.19188,
    ry: 1.17734,
    fill: "#3D3434"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.021,
    cy: 62.2579,
    rx: 1.19188,
    ry: 1.17734,
    fill: "#3D3434"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.4466,
    cy: 53.5777,
    rx: 1.19188,
    ry: 1.17734,
    fill: "#3D3434"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.638,
    cy: 44.1617,
    rx: 1.19188,
    ry: 1.17734,
    fill: "#3D3434"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.6382,
    cy: 34.5987,
    rx: 1.19188,
    ry: 1.17734,
    fill: "#3D3434"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.1283,
    cy: 67.9957,
    rx: 1.19188,
    ry: 1.17734,
    fill: "#3D3434"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.2773,
    cy: 61.0812,
    rx: 1.19188,
    ry: 1.17734,
    fill: "#3D3434"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.4471,
    cy: 70.3502,
    rx: 1.19188,
    ry: 1.17734,
    fill: "#3D3434"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3415 72.9976L70.1072 66.5241L79.3415 64.9058V72.9976Z",
    fill: "#9AC869"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7437 36.185L26.1308 40.6386L17.4327 44.1029L15.7437 36.185Z",
    fill: "#9AC869"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTat);
export default __webpack_public_path__ + "static/media/tat.622425a14c8fe12a40e93428f54b413d.svg";
export { ForwardRef as ReactComponent };